module.exports = __webpack_public_path__ + "static/media/plant-floor.3aa9c1db.png";